<app-cardpage-base [loading]="loading">
  <p-card class="card-layout block h-full min-h-0 w-full"
          styleClass="flex h-full min-h-0 flex-col">
    <ng-template #title>
      <div class="grid grid-cols-2 content-center gap-4">
        <span class="text-xl font-bold">{{ getTitle() }}</span>
        <div class="flex flex-row gap-4 justify-self-end">
          <p-button variant="outlined" icon="pi pi-user-plus" [label]="'newUser' | translate" (click)="onNewUser()" />
        </div>
      </div>
    </ng-template>
    <ng-template #subtitle>
      <div class="flex flex-row items-center gap-4">
        <span class="text-base">{{ 'titles.dashboardClinicSub' | translate:{ patients: dashboard.patients, alerts: dashboard.alerts } }}</span>
      </div>
    </ng-template>

    <div class="flex h-full min-h-0 flex-col gap-4 pb-4">
      <div class="grid grid-cols-5 gap-4">
        <p-panel [header]="'patientsActive' | translate" class="text-xs">
          <div class="flex flex-col">
            <div class="flex items-end gap-2">
              <span class="text-3xl font-semibold">{{ dashboard.active24 }}</span>
            </div>
            <span class="justify-end text-xs">{{ 'last24h' | translate }}</span>
            <p-divider />
            <div class="flex items-baseline gap-2">
              <span class="text-lg font-medium">{{ dashboard.active30 }}</span>
            </div>
            <span class="justify-end text-xs">{{ 'lastMonth' | translate }}</span>
          </div>
        </p-panel>

        <p-panel [header]="'monitoringHours' | translate" class="text-sm">
          <div class="flex flex-col">
            <div class="flex items-end gap-2">
              <span class="text-3xl font-semibold">{{ dashboard.monitor24 }}</span>
              <span class="text-sm">hh:mm</span>
            </div>
            <span class="justify-end text-xs lowercase">{{ 'primeng.today'| translate }}</span>
            <p-divider />
            <div class="flex items-baseline gap-2">
              <span class="text-lg font-medium">{{ dashboard.monitor30 }}</span>
              <span class="text-xs">hh:mm</span>
            </div>
            <span class="justify-end text-xs">{{ 'lastMonth' | translate }}</span>
          </div>
        </p-panel>

        <p-panel [header]="'alerts' | translate" class="text-sm">
          <div class="flex flex-col">
            <div class="flex items-end gap-2">
              <span class="text-3xl font-semibold text-red-600">{{ dashboard.alerts }}</span>
            </div>
            <span class="justify-end text-xs">{{ 'toAnalyse' | translate }}</span>
            <p-divider />
            <div class="flex items-baseline gap-2">
              <span class="text-lg font-medium">{{ dashboard.alerts30 }}</span>
            </div>
            <span class="justify-end text-xs">{{ 'lastMonth' | translate }}</span>
          </div>
        </p-panel>

        <p-panel [header]="'reportCreated' | translate" class="text-sm">
          <div class="flex flex-col">
            <div class="flex items-end gap-2">
              <span class="text-3xl font-semibold">{{ dashboard.report24 }}</span>
            </div>
            <span class="justify-end text-xs">{{ 'last24h' | translate }}</span>
            <p-divider />
            <div class="flex items-baseline gap-2">
              <span class="text-lg font-medium">{{ dashboard.report30 }}</span>
            </div>
            <span class="justify-end text-xs">{{ 'lastMonth' | translate }}</span>
          </div>
        </p-panel>
      </div>

      <div class="flex h-full min-h-0 flex-col">
        <span class="font-bold">{{ 'patients' | translate}} {{ 'with' | translate }} {{ 'alerts' | translate }} {{ 'toAnalyse' | translate }}</span>
        <p-table [value]="dashboard.users"
                 [paginator]="true" [rows]="10" [rowsPerPageOptions]="[5, 10, 25]"
                 [scrollable]="true" scrollHeight="flex"
                 stripedRows
                 class="flex h-full min-h-0 flex-col">
          <ng-template #header>
            <tr class="text-sm" app-patient-header></tr>
          </ng-template>
          <ng-template #body let-user>
            <tr app-patient-row [user]="user" [messageService]="messageService" [routerService]="routerService"></tr>
          </ng-template>
        </p-table>
      </div>
    </div>
</p-card>

  <app-user-dialog [isNew]="true"
                   [messageService]="messageService"
                   [(visible)]="showDialogUser"
                   [user]="newUser"
                   (saved)="onUserSaved($event)">
  </app-user-dialog>
</app-cardpage-base>
